import type { AxiosError } from 'axios'

/** Laravel validation payload: field key → list of messages. */
export type LaravelValidationErrors = Record<string, string[]>

/**
 * First message per field, for simple bindings (Message, small text).
 */
export function flattenLaravelValidationErrors(
  errors: LaravelValidationErrors | undefined | null
): Record<string, string> {
  const out: Record<string, string> = {}
  if (!errors) return out
  for (const [key, messages] of Object.entries(errors)) {
    const first = messages?.[0]
    if (first) out[key] = first
  }
  return out
}

/**
 * Shape used by @primevue/forms resolvers: field name → list of `{ message }`.
 */
export function laravelErrorsToPrimeVueFieldErrors(
  errors: LaravelValidationErrors | undefined | null
): Record<string, { message: string }[]> {
  const out: Record<string, { message: string }[]> = {}
  if (!errors) return out
  for (const [key, messages] of Object.entries(errors)) {
    const list = Array.isArray(messages) ? messages : [String(messages)]
    out[key] = list.map((m) => ({ message: m }))
  }
  return out
}

export function getLaravelValidationErrorsFromAxios(
  err: unknown
): LaravelValidationErrors | undefined {
  const ax = err as AxiosError<{ errors?: LaravelValidationErrors; message?: string }>
  return ax.response?.data?.errors
}
